import { render, staticRenderFns } from "./HowToUseScreen.vue?vue&type=template&id=1082c1ce&scoped=true"
import script from "./HowToUseScreen.vue?vue&type=script&lang=js"
export * from "./HowToUseScreen.vue?vue&type=script&lang=js"
import style0 from "./HowToUseScreen.vue?vue&type=style&index=0&id=1082c1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1082c1ce",
  null
  
)

export default component.exports